import React from "react";
import {LogoBox} from "../../Style/Header";

export const Logo = () => {
  return (
    <LogoBox/>
  )
}